import useSelectedOrganization from '@/hooks/useSelectedOrganization';

/**
 * A potential client has self-registered but has no counterparty/organization yet — their cabinet
 * stays empty until Supply signs a contract with them and the contact-person sync links them to a
 * real counterparty. `isLoading` covers the initial user fetch so callers don't flash
 * the locked state before we actually know whether the user has an organization.
 */
const usePotentialClient = () => {
  const { organizations, isLoading } = useSelectedOrganization();

  return {
    isPotentialClient: !isLoading && organizations.length === 0,
    isLoading,
  };
};

export default usePotentialClient;
